import { lazy } from 'react'

import SubscriptionLoader from './loader'

export default {
  Subscription: {
    Component: lazy(() => import('./ManageSubscription.Page')),
    Loader: SubscriptionLoader,
  },
}
